const arr: { [key: string]: any }[] = [
  {
    "id": 3,
    "youtube": "BQ2F9p_vw60",
    "name": "הסבר על סרגל  כלים העליון",
    "title": "הסברים כלליים",
    "origin": "tutorials",
    "index": 0
  },
  {
    "id": 2,
    "youtube": "KDkurhKUABk",
    "name": "סרטון הדרכה על שימוש באתר",
    "title": "הסברים כלליים",
    "origin": "tutorials",
    "index": 1
  },
  {
    "id": 4,
    "youtube": "Ta7S2QQpRmU",
    "name": "שמירה ושיתופיות ביישומטיקה",
    "title": "הסברים כלליים",
    "origin": "tutorials",
    "index": 2
  },
  {
    "id": 5,
    "youtube": "VL7Ppi0UWH8",
    "name": "פאזלים",
    "title": "למידה מרחוק",
    "origin": "tutorials",
    "index": 3
  },
  {
    "id": 6,
    "youtube": "sk3j-arwHY8",
    "name": "שליחת מבדק",
    "title": "למידה מרחוק",
    "origin": "tutorials",
    "index": 4
  },
  {
    "id": 7,
    "youtube": "6X5q8oPtWp8",
    "name": "יצירה ושיתוף עם קהילת יישומטיקה",
    "title": "למידה מרחוק",
    "origin": "tutorials",
    "index": 5
  },
  {
    "id": 8,
    "youtube": "0m61c1tsEew",
    "name": "יצירת מבדק",
    "title": "למידה מרחוק",
    "origin": "tutorials",
    "index": 6
  },
  {
    "id": 9,
    "youtube": "Smqtlq_5Oyc",
    "name": "העברת שיעור סינכרוני",
    "title": "למידה מרחוק",
    "origin": "tutorials",
    "index": 7
  },
  {
    "id": 10,
    "youtube": "AJbrLu_e5E0",
    "name": "הפיכת שיעור ביישומטיקה לשיעור סינכרוני אינטראקטיבי",
    "title": "למידה מרחוק",
    "origin": "tutorials",
    "index": 8
  },
  {
    "id": 11,
    "youtube": "YxH0nbfGWLA",
    "name": "שכפול אובייקטים",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 9
  },
  {
    "id": 12,
    "youtube": "WDLI0ziKg7s",
    "name": "שימוש בתיבת מספר",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 10
  },
  {
    "id": 13,
    "youtube": "kwcGPy3yjMQ",
    "name": "שימוש בתיבת טקסט",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 11
  },
  {
    "id": 14,
    "youtube": "lb-DICuIsSI",
    "name": "שימוש בטיימר",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 12
  },
  {
    "id": 15,
    "youtube": "YLItYwEnz70",
    "name": "שימוש בטבלה",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 13
  },
  {
    "id": 16,
    "youtube": "1J_49AD3S-E",
    "name": "מחיקת אובייקטים",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 14
  },
  {
    "id": 17,
    "youtube": "6L4YoWrkwPI",
    "name": "טעינה מוקדמת של עמודי שיעור",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 15
  },
  {
    "id": 18,
    "youtube": "Z_THHrcFbkY",
    "name": "העברת עמודים בתוך יישומון ובין יישומונים",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 16
  },
  {
    "id": 19,
    "youtube": "kgZE8c8R5MA",
    "name": "הכנסת תמונות",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 17
  },
  {
    "id": 20,
    "youtube": "vIMZslzJcw0",
    "name": "החלפת צבע הרקע של המסך",
    "title": "סרטונים קצרים",
    "origin": "tutorials",
    "index": 18
  },
  {
    "id": 22,
    "youtube": "ydfflfPIfho",
    "name": "הקלטה, שמירה ושיתוף סרטונים",
    "title": "הסברים כלליים",
    "origin": "tutorials",
    "index": 19
  }
]
export default arr;